// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/diabetes.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2017, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.CBGMedianAnimated--thickStroke--Wx2Gy {
  stroke-width: 2;
}

.CBGMedianAnimated--median--k0A2B {
  stroke: white;
  pointer-events: none;
}

.CBGMedianAnimated--transparent--kx5dj {
  fill: transparent;
}

@keyframes CBGMedianAnimated--fadein--bca1E {
  from {
    fill-opacity: 0.0;
  }
  to {
    fill-opacity: 1.0;
  }
}

@keyframes CBGMedianAnimated--fadeout--Nt8UK {
  from {
    fill-opacity: 1.0;
  }
  to {
    fill-opacity: 0.0;
  }
}

.CBGMedianAnimated--fadeinAnimation--utaIE {
  animation: CBGMedianAnimated--fadein--bca1E 0.25s forwards ease-in-out;
}

.CBGMedianAnimated--fadeoutAnimation--n13Mx {
  animation: CBGMedianAnimated--fadeout--Nt8UK 0.25s forwards ease-in-out;
}

.CBGMedianAnimated--veryLowFadeIn--_N23o {
}

.CBGMedianAnimated--veryLowFadeOut--jWEjT {
}

.CBGMedianAnimated--lowFadeIn--EKzYQ {
}

.CBGMedianAnimated--lowFadeOut--VPbPd {
}

.CBGMedianAnimated--targetFadeIn--ElQaq {
}

.CBGMedianAnimated--targetFadeOut--U4eiD {
}

.CBGMedianAnimated--highFadeIn--MczpY {
}

.CBGMedianAnimated--highFadeOut--p_Ovq {
}

.CBGMedianAnimated--veryHighFadeIn--ZJV62 {
}

.CBGMedianAnimated--veryHighFadeOut--O_jFk {
}
`, "",{"version":3,"sources":["webpack://./src/components/trends/cbg/CBGMedianAnimated.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAMF;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EAEb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,sEAA4C;AAC9C;;AAEA;EACE,uEAA6C;AAC/C;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA;;AAEA;AAGA","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2017, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n:export {\n  stroke: 2;\n}\n\n.thickStroke {\n  stroke-width: 2;\n}\n\n.median {\n  stroke: white;\n  composes: thickStroke;\n  pointer-events: none;\n}\n\n.transparent {\n  fill: transparent;\n}\n\n@keyframes fadein {\n  from {\n    fill-opacity: 0.0;\n  }\n  to {\n    fill-opacity: 1.0;\n  }\n}\n\n@keyframes fadeout {\n  from {\n    fill-opacity: 1.0;\n  }\n  to {\n    fill-opacity: 0.0;\n  }\n}\n\n.fadeinAnimation {\n  animation: fadein 0.25s forwards ease-in-out;\n}\n\n.fadeoutAnimation {\n  animation: fadeout 0.25s forwards ease-in-out;\n}\n\n.veryLowFadeIn {\n  composes: bgVeryLow from '../../../styles/diabetes.css';\n  composes: fadeinAnimation;\n}\n\n.veryLowFadeOut {\n  composes: bgVeryLow from '../../../styles/diabetes.css';\n  composes: fadeoutAnimation;\n}\n\n.lowFadeIn {\n  composes: bgLow from '../../../styles/diabetes.css';\n  composes: fadeinAnimation;\n}\n\n.lowFadeOut {\n  composes: bgLow from '../../../styles/diabetes.css';\n  composes: fadeoutAnimation;\n}\n\n.targetFadeIn {\n  composes: bgTarget from '../../../styles/diabetes.css';\n  composes: fadeinAnimation;\n}\n\n.targetFadeOut {\n  composes: bgTarget from '../../../styles/diabetes.css';\n  composes: fadeoutAnimation;\n}\n\n.highFadeIn {\n  composes: bgHigh from '../../../styles/diabetes.css';\n  composes: fadeinAnimation;\n}\n\n.highFadeOut {\n  composes: bgHigh from '../../../styles/diabetes.css';\n  composes: fadeoutAnimation;\n}\n\n.veryHighFadeIn {\n  composes: bgVeryHigh from '../../../styles/diabetes.css';\n  composes: fadeinAnimation;\n}\n\n.veryHighFadeOut {\n  composes: bgVeryHigh from '../../../styles/diabetes.css';\n  composes: fadeoutAnimation;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stroke": `2`,
	"thickStroke": `CBGMedianAnimated--thickStroke--Wx2Gy`,
	"median": `CBGMedianAnimated--median--k0A2B CBGMedianAnimated--thickStroke--Wx2Gy`,
	"transparent": `CBGMedianAnimated--transparent--kx5dj`,
	"fadeinAnimation": `CBGMedianAnimated--fadeinAnimation--utaIE`,
	"fadein": `CBGMedianAnimated--fadein--bca1E`,
	"fadeoutAnimation": `CBGMedianAnimated--fadeoutAnimation--n13Mx`,
	"fadeout": `CBGMedianAnimated--fadeout--Nt8UK`,
	"veryLowFadeIn": `CBGMedianAnimated--veryLowFadeIn--_N23o ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgVeryLow"]} CBGMedianAnimated--fadeinAnimation--utaIE`,
	"veryLowFadeOut": `CBGMedianAnimated--veryLowFadeOut--jWEjT ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgVeryLow"]} CBGMedianAnimated--fadeoutAnimation--n13Mx`,
	"lowFadeIn": `CBGMedianAnimated--lowFadeIn--EKzYQ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgLow"]} CBGMedianAnimated--fadeinAnimation--utaIE`,
	"lowFadeOut": `CBGMedianAnimated--lowFadeOut--VPbPd ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgLow"]} CBGMedianAnimated--fadeoutAnimation--n13Mx`,
	"targetFadeIn": `CBGMedianAnimated--targetFadeIn--ElQaq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgTarget"]} CBGMedianAnimated--fadeinAnimation--utaIE`,
	"targetFadeOut": `CBGMedianAnimated--targetFadeOut--U4eiD ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgTarget"]} CBGMedianAnimated--fadeoutAnimation--n13Mx`,
	"highFadeIn": `CBGMedianAnimated--highFadeIn--MczpY ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgHigh"]} CBGMedianAnimated--fadeinAnimation--utaIE`,
	"highFadeOut": `CBGMedianAnimated--highFadeOut--p_Ovq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgHigh"]} CBGMedianAnimated--fadeoutAnimation--n13Mx`,
	"veryHighFadeIn": `CBGMedianAnimated--veryHighFadeIn--ZJV62 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgVeryHigh"]} CBGMedianAnimated--fadeinAnimation--utaIE`,
	"veryHighFadeOut": `CBGMedianAnimated--veryHighFadeOut--O_jFk ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bgVeryHigh"]} CBGMedianAnimated--fadeoutAnimation--n13Mx`
};
export default ___CSS_LOADER_EXPORT___;
